var render, staticRenderFns
import script from "./GlobeScene.vue?vue&type=script&lang=js&"
export * from "./GlobeScene.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c32ef6",
  null
  
)

export default component.exports